<template>
  <div>
    <div class="collect_history-list">
      <div v-for="item in goodsList" :key="item.id" class="prod-list-item" @click="toProdDetail(item)">
        <div class="prod-list-item-img">
          <img :src="item.imageUrl" alt="" />
        </div>
        <div class="prod-name">{{ item.categoryName }}</div>
        <div class="prod-model"> {{ item.productModel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'goods-show',
    props:{
      goodsList: {
        type: Array,
        default: function () {
          return []
        }
      },
      idType: {
        type: String,
        default: 'id'
      }
    },
    data () {
      return {
      }
    },
    components:{
    },
    created(){
    },
    methods:{
      toProdDetail(item) {
        const tempId = this.idType === 'productId' ? item.productId : item.id;
        this.$router.push({
          name: 'app',
          query: {
            id: tempId
          },
        });
//      this.$router.push(`/app`);
//      this.$route.query.id = tempId;
      },
    }
  }
</script>

<style scoped>
.collect_history-list {
  padding: 18px 32px 44px;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;

}
.prod-list-item {
  width: 300px;
  height: 407px;
  margin-bottom: 48px;
}
.prod-list-item-img {
  background: rgba(0, 0, 0, 2%);
  border-radius: 16px;
  overflow: hidden;
}
.prod-list-item-img img {
  border-radius: 16px;
  width: 299px;
  height: 299px;
}
.prod-name {
  width: 90%;
  margin-left: 8%;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
  font-size: 32px;
  color: #333333;
  overflow: hidden;
}
.prod-model {
  width: 90%;
  margin-left: 8%;
  height: 36px;
  line-height: 36px;
  color: #999999;
  margin-top: 4px;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/retail/components/goodsShow.vue